import React from 'react';
import { toast } from 'react-toastify';
toast.configure();
const Products = () => {
    const handleSubmit = () => {
        toast.success("Product added to cart")
    };
    return(
        <div className="container" style={{maxWidth: "100%"}}>
            <div className="row row-cols-8 mb-2" style={{position:"absolute",marginLeft:"30px",marginRight:"30px"}}>
                <div className="card text-white bg-info mb-3 text-center col-xs-7 col-sm-6 col-md-5 col-lg-4 col-xl-3" style={{marginRight:"6px",marginLeft:"6px"}}>
                    <div className="card-header">
                        <span>BAMBOO BIRIYANI</span>
                    </div>
                    <img src={process.env.PUBLIC_URL + "/uploads/Screenshot_20201120_101348-1605924759313.jpg"} alt="BAMBOO BIRIYANI" className="card-img-top" style={{border: "1px solid #ddd" , borderRadius: "4px", padding:"5px", height: "200px"}}/>
                    <div className="card-body">
                        <p className="ard-text">Full Plate ,  tasty biriyani</p>
                        <p className="card-text">450</p>
                        <div className="btn-group dropright">
                            <button type="button" className="btn btn-success" data-toggle="modal" onClick={handleSubmit}>
                                <i className="fas fa-shopping-cart" id="cart-logo" data-toggle="modal" data-target="#cart"></i>
                            </button>
                            <select className="btn btn-info">
                                <option disabled="">Quantity</option>
                                <option value="1">1 Qty</option>
                                <option value="2">2 Qty</option>
                                <option value="3">3 Qty</option>
                                <option value="4">4 Qty</option>
                                <option value="5">5 Qty</option>
                                <option value="6">6 Qty</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="card text-white bg-info mb-3 text-center col-xs-7 col-sm-6 col-md-5 col-lg-4 col-xl-3" style={{marginRight:"6px",marginLeft:"6px"}}>
                    <div className="card-header"><span>BEEF KIZHI</span></div>
                    <img src={process.env.PUBLIC_URL + "/uploads/no-image-available-icon.jpg"} className="card-img-top" alt="BEEF KIZHI" style={{border: "1px solid #ddd" , borderRadius: "4px", padding:"5px", height: "200px"}}/>
                    <div className="card-body">
                        <p className="ard-text">Full Plate , tasty</p>
                        <p className="card-text">600</p>
                        <div className="btn-group dropright">
                            <button type="button" className="btn btn-success" data-toggle="modal" onClick={handleSubmit}>
                                <i className="fas fa-shopping-cart" id="cart-logo" data-toggle="modal" data-target="#cart"></i>
                            </button>
                            <select className="btn btn-info">
                                <option disabled="">Quantity</option>
                                <option value="1">1 Qty</option>
                                <option value="2">2 Qty</option>
                                <option value="3">3 Qty</option>
                                <option value="4">4 Qty</option>
                                <option value="5">5 Qty</option>
                                <option value="6">6 Qty</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="card text-white bg-info mb-3 text-center col-xs-7 col-sm-6 col-md-5 col-lg-4 col-xl-3" style={{marginRight:"6px",marginLeft:"6px"}}>
                    <div className="card-header">
                        <span>KAPPA BIRIYANI</span>
                    </div>
                    <img src={process.env.PUBLIC_URL + "/uploads/Screenshot_20201120_101500-1605925031508.jpg"} className="card-img-top" alt="KAPPA BIRIYANI" style={{border: "1px solid #ddd" , borderRadius: "4px", padding:"5px", height: "200px"}}/>
                    <div className="card-body">
                        <p className="ard-text">Full Plate ,  kappa, tasty biriyani</p>
                        <p className="card-text">240</p>
                        <div className="btn-group dropright">
                            <button type="button" className="btn btn-success" data-toggle="modal" onClick={handleSubmit}>
                                <i className="fas fa-shopping-cart" id="cart-logo" data-toggle="modal" data-target="#cart"></i>
                            </button>
                            <select className="btn btn-info">
                                <option disabled="">Quantity</option>
                                <option value="1">1 Qty</option>
                                <option value="2">2 Qty</option>
                                <option value="3">3 Qty</option>
                                <option value="4">4 Qty</option>
                                <option value="5">5 Qty</option>
                                <option value="6">6 Qty</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="card text-white bg-info mb-3 text-center col-xs-7 col-sm-6 col-md-5 col-lg-4 col-xl-3" style={{marginRight:"6px",marginLeft:"6px"}}>
                    <div className="card-header">
                        <span>POTHI CHOR</span>
                    </div>
                    <img src={process.env.PUBLIC_URL +"/uploads/Screenshot_20201120_101436-1605925091230.jpg"} className="card-img-top" alt="POTHI CHOR" style={{border: "1px solid #ddd" , borderRadius: "4px", padding:"5px", height: "200px"}}/>
                    <div className="card-body">
                        <p className="ard-text">one plate , with sambar and chatny</p>
                        <p className="card-text">180</p>
                        <div className="btn-group dropright">
                            <button type="button" className="btn btn-success" data-toggle="modal" onClick={handleSubmit}>
                                <i className="fas fa-shopping-cart" id="cart-logo" data-toggle="modal" data-target="#cart"></i>
                            </button>
                            <select className="btn btn-info">
                                <option disabled="">Quantity</option>
                                <option value="1">1 Qty</option>
                                <option value="2">2 Qty</option>
                                <option value="3">3 Qty</option>
                                <option value="4">4 Qty</option>
                                <option value="5">5 Qty</option>
                                <option value="6">6 Qty</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Products;